import React from "react";
import { useSelector } from "react-redux";
import VisibilitySensor from "react-visibility-sensor";
import constants from "../assets/js/constants";
import {
  getAnimationNameBasedOnList,
  getAnimationNameBasedOnListWIthSeparators,
  getRightContent,
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import useWindowSize from "./hooks/useWindowSize";
import PencilShapeItem from "./PencilShapeItem";

function PencilShape({
  title,
  topShape,
  bottomShape,
  applyOpacity,
  items,
  backgroundColor = constants.COLORS.PRIMARY,
  images,
  titleColor = "white",
}) {
  const windowWidth = useWindowSize();
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <div className="pencil-shape">
      {topShape && (
        <div
          style={{ backgroundColor }}
          className={`pencil-shape__top${setAdditionalClasses(
            ["apply-opacity"],
            [applyOpacity]
          )}`}
        ></div>
      )}

      {title && (
        <div
          className="center-wrapper"
          style={{
            backgroundColor,
          }}
        >
          <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
              <h3
                className="pencil-shape__heading"
                style={{
                  color: titleColor,
                  ...getVisibleSensorAnimation(
                    isVisible,
                    "fadeInReverse 1s .5s backwards"
                  ),
                }}
              >
                {title}
              </h3>
            )}
          </VisibilitySensor>
        </div>
      )}
      <div className="pencil-shape__body" style={{ backgroundColor }}>
        {items.map(
          (item, index) =>
            // <div key={index}>
            //   {index === 1 && (
            //     <div
            //       // style={{ height: "100px" }}
            //       className={`padding-separator${setAdditionalClasses(
            //         ["background-secondary"],
            //         [item.secondarySeparator]
            //       )}`}
            //     />
            //   )}
            //   {index === 2 && (
            //     <div
            //       // style={{ height: "100px" }}
            //       className={`padding-separator${setAdditionalClasses(
            //         ["background-secondary"],
            //         [item.secondarySeparator]
            //       )}`}
            //     />
            //   )}
            index % 2 !== 0 ? (
              <div
                // style={{ height: "100%" }}
                className={`padding-separator${setAdditionalClasses(
                  ["background-secondary", "first-pencil-shape"],
                  [item.secondarySeparator, item.firstPencilShape]
                )}`}
              />
            ) : (
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <div
                    className="pencil-shape__item"
                    key={index}
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `${getAnimationNameBasedOnListWIthSeparators(
                        index,
                        items.length
                      )} 1.5s ${
                        //   windowWidth > 767 ? index * 0.25 : 0.5
                        0.5
                      }s backwards`
                    )}
                  >
                    <PencilShapeItem
                      mainTitleColor={item.mainTitleColor}
                      image={images[index]}
                      mainTitle={getRightContent(
                        generalSettings.rtlLanguage,
                        item.mainTitle || ["", ""]
                      )}
                      subTitle={getRightContent(
                        generalSettings.rtlLanguage,
                        item.subTitle || ["", ""]
                      )}
                      text={getRightContent(
                        generalSettings.rtlLanguage,
                        item.text || ["", ""]
                      )}
                    />
                  </div>
                )}
              </VisibilitySensor>
            )
          // </div>
        )}
      </div>
      {bottomShape && (
        <div
          style={{ backgroundColor }}
          className={`pencil-shape__bottom${setAdditionalClasses(
            ["apply-opacity"],
            [applyOpacity]
          )}`}
        ></div>
      )}
    </div>
  );
}

export default PencilShape;
